import { scopeBar } from "./vampStanding";

interface VampScopeBarProps {
  events: number;
  elapsed: number;
  size?: "sm" | "md";
  label?: string;
}

const SIZE = {
  sm: {
    track: "h-1.5 rounded-[3px]",
    fill: "h-1.5 rounded-[3px]",
    notch: "absolute -top-0.5 right-0 h-2.5 w-0.5 rounded-[1px] bg-gray-300",
  },
  md: {
    track: "h-2 rounded",
    fill: "h-2 rounded",
    notch: "absolute -top-[3px] right-0 h-3.5 w-0.5 rounded-[1px] bg-gray-400",
  },
} as const;

export default function VampScopeBar({ events, elapsed, size = "md", label }: VampScopeBarProps) {
  const { usedPct, projectedPct } = scopeBar(events, elapsed);
  const s = SIZE[size];

  return (
    <div>
      <div className={`relative bg-gray-100 ${s.track}`}>
        <div className={`absolute left-0 top-0 bg-brand-200 ${s.fill}`} style={{ width: `${projectedPct}%` }} />
        <div className={`absolute left-0 top-0 bg-brand-500 ${s.fill}`} style={{ width: `${usedPct}%` }} />
        <div className={s.notch} />
      </div>
      {label != null && <div className="mt-1 text-right text-[11px] leading-[15px] text-gray-400 tabular-nums">{label}</div>}
    </div>
  );
}
